module.exports = __webpack_public_path__ + "static/img/a114.598f6a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a114.jpg
// module id = zu2Y
// module chunks = 0